import { HttpClient } from '@medprompt/shared';

/**
 * IssueService - Handles issue reporting API operations
 * Uses HttpClient directly since these endpoints are on the identity server
 */
export class IssueService {
  constructor() {
    this.httpClient = new HttpClient();
    
    // Environment configuration
    this.authBaseUrl = process.env.REACT_APP_IDENTITY_SERVER_URL;
    
    console.log('IssueService initialized');
  }

  /**
   * Create a new issue
   * @param {Object} issueData - The issue data containing type, source, and description
   * @returns {Promise<void>}
   */
  async createIssue(issueData) {
    const response = await this.httpClient.post(
      `${this.authBaseUrl}/api/issue/create`,
      issueData
    );
    this.httpClient.checkResponse(response);
    // Void endpoint - no response to parse
  }
}

